import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Search, Users, Building2, ChevronDown, ChevronRight, Plus, X, ChevronLeft } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/* ───── Modal agregar persona Lomas Bayas ───── */
function ModalAgregarMandante({ token, areas, cargos, onClose, onCreated }) {
  const [form, setForm] = useState({ rut: '', nombre: '', apellido: '', email: '', sexo: '', nacionalidad: '', jornada: '', cargo_id: '', area_id: '', fecha_ingreso: '' });
  const [saving, setSaving] = useState(false);
  const u = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const submit = async () => {
    if (!form.rut || !form.nombre || !form.apellido || !form.area_id) { toast.error('Complete RUT, Nombre, Apellido y Area'); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/personas`, form, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Persona agregada exitosamente');
      onCreated();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al crear persona');
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg mx-4 p-5 space-y-4" onClick={e => e.stopPropagation()} data-testid="modal-agregar-mandante">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-bold text-slate-800">Agregar Persona - Lomas Bayas</h3>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded-lg"><X className="w-4 h-4" /></button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">RUT *</label>
            <input value={form.rut} onChange={e => u('rut', e.target.value)} placeholder="12.345.678-9" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="input-rut" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Email</label>
            <input value={form.email} onChange={e => u('email', e.target.value)} placeholder="correo@empresa.cl" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Nombre *</label>
            <input value={form.nombre} onChange={e => u('nombre', e.target.value)} placeholder="Nombre" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="input-nombre" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Apellido *</label>
            <input value={form.apellido} onChange={e => u('apellido', e.target.value)} placeholder="Apellido" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="input-apellido" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Area *</label>
            <select value={form.area_id} onChange={e => u('area_id', e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="select-area">
              <option value="">Seleccione</option>
              {areas.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Cargo</label>
            <select value={form.cargo_id} onChange={e => u('cargo_id', e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm">
              <option value="">Seleccione</option>
              {cargos.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Sexo</label>
            <select value={form.sexo} onChange={e => u('sexo', e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm">
              <option value="">Seleccione</option>
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </select>
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Nacionalidad</label>
            <input value={form.nacionalidad} onChange={e => u('nacionalidad', e.target.value)} placeholder="Chilena" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Jornada</label>
            <input value={form.jornada} onChange={e => u('jornada', e.target.value)} placeholder="Turno 4x3" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Fecha Ingreso</label>
            <input type="date" value={form.fecha_ingreso} onChange={e => u('fecha_ingreso', e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onClose} className="px-4 py-2 text-sm text-slate-500 hover:bg-slate-100 rounded-lg">Cancelar</button>
          <button onClick={submit} disabled={saving} className="px-4 py-2 text-sm bg-[#1B919B] text-white rounded-lg hover:bg-[#167a83] disabled:opacity-50" data-testid="btn-guardar-mandante">
            {saving ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ───── Modal agregar trabajador contratista ───── */
function ModalAgregarContratista({ token, empresaId, empresaNombre, onClose, onCreated }) {
  const [form, setForm] = useState({ rut: '', nombre: '', apellido: '', cargo: '', email: '', fono: '' });
  const [saving, setSaving] = useState(false);
  const u = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const submit = async () => {
    if (!form.rut || !form.nombre || !form.apellido) { toast.error('Complete RUT, Nombre y Apellido'); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/empresas-mandante2/${empresaId}/trabajadores`, form, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Trabajador agregado exitosamente');
      onCreated();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al crear trabajador');
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-5 space-y-4" onClick={e => e.stopPropagation()} data-testid="modal-agregar-contratista">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base font-bold text-slate-800">Agregar Trabajador</h3>
            <p className="text-xs text-slate-400">{empresaNombre}</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded-lg"><X className="w-4 h-4" /></button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">RUT *</label>
            <input value={form.rut} onChange={e => u('rut', e.target.value)} placeholder="12.345.678-9" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="input-rut-cont" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Email</label>
            <input value={form.email} onChange={e => u('email', e.target.value)} placeholder="correo@empresa.cl" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Nombre *</label>
            <input value={form.nombre} onChange={e => u('nombre', e.target.value)} placeholder="Nombre" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="input-nombre-cont" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Apellido *</label>
            <input value={form.apellido} onChange={e => u('apellido', e.target.value)} placeholder="Apellido" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="input-apellido-cont" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Cargo</label>
            <input value={form.cargo} onChange={e => u('cargo', e.target.value)} placeholder="Cargo" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-slate-400 uppercase mb-1">Telefono</label>
            <input value={form.fono} onChange={e => u('fono', e.target.value)} placeholder="+56912345678" className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onClose} className="px-4 py-2 text-sm text-slate-500 hover:bg-slate-100 rounded-lg">Cancelar</button>
          <button onClick={submit} disabled={saving} className="px-4 py-2 text-sm bg-[#a05e49] text-white rounded-lg hover:bg-[#8b4f3d] disabled:opacity-50" data-testid="btn-guardar-contratista">
            {saving ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ───── Tab Lomas Bayas ───── */
function PersonasMandante({ token }) {
  const headers = { Authorization: `Bearer ${token}` };
  const [allPersonas, setAllPersonas] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [areas, setAreas] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const [pRes, aRes, cRes] = await Promise.all([
        axios.get(`${API}/personas`, { headers }),
        axios.get(`${API}/areas`, { headers }),
        axios.get(`${API}/cargos`, { headers }),
      ]);
      setAllPersonas(pRes.data);
      setAreas(aRes.data);
      setCargos(cRes.data);
    } catch {}
    setLoading(false);
  }, [token]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const getAreaName = (id) => areas.find(a => a.id === id)?.nombre || '';

  const filtered = search.length >= 2
    ? allPersonas.filter(p => {
        const q = search.toLowerCase();
        const full = `${p.nombre} ${p.apellido}`.toLowerCase();
        return full.includes(q) || (p.rut || '').toLowerCase().includes(q);
      })
    : allPersonas;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Buscar por nombre o RUT..."
            className="w-full pl-10 pr-4 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1B919B]/20"
            data-testid="search-mandante" />
        </div>
        <button onClick={() => setShowModal(true)}
          className="flex items-center gap-1.5 px-4 py-2.5 bg-[#1B919B] text-white text-sm rounded-lg hover:bg-[#167a83] transition-colors whitespace-nowrap"
          data-testid="btn-agregar-mandante">
          <Plus className="w-4 h-4" /> Agregar
        </button>
      </div>

      <div className="border border-slate-200 rounded-lg overflow-hidden">
        <div className="max-h-[500px] overflow-y-auto">
          <table className="w-full" data-testid="table-mandante">
            <thead className="sticky top-0 bg-slate-50 z-10">
              <tr className="border-b border-slate-200">
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase whitespace-nowrap">RUT</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Nombre</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Cargo</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Area</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Email</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Sexo</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Nacionalidad</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Jornada</th>
                <th className="text-left px-3 py-2.5 text-[10px] font-semibold text-slate-400 uppercase">Ingreso</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {loading ? (
                <tr><td colSpan={9} className="px-3 py-8 text-center"><div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#1B919B] mx-auto" /></td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={9} className="px-3 py-8 text-center text-sm text-slate-400">No se encontraron resultados</td></tr>
              ) : filtered.map(p => (
                <tr key={p.id} className="hover:bg-slate-50 transition-colors" data-testid={`mandante-row-${p.id}`}>
                  <td className="px-3 py-2 text-xs font-mono text-slate-600 whitespace-nowrap">{p.rut || ''}</td>
                  <td className="px-3 py-2 text-xs text-slate-800 font-medium whitespace-nowrap">{p.nombre} {p.apellido}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{p.cargo_nombre || ''}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{getAreaName(p.area_id)}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{p.email || ''}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{p.sexo || ''}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{p.nacionalidad || ''}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{p.jornada || ''}</td>
                  <td className="px-3 py-2 text-xs text-slate-500 whitespace-nowrap">{p.fecha_ingreso || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <p className="text-[10px] text-slate-400">{filtered.length} de {allPersonas.length} persona(s)</p>

      {showModal && <ModalAgregarMandante token={token} areas={areas} cargos={cargos} onClose={() => setShowModal(false)} onCreated={fetchAll} />}
    </div>
  );
}

/* ───── Empresa Card (Contratista) ───── */
function EmpresaCard({ empresa, token }) {
  const headers = { Authorization: `Bearer ${token}` };
  const [open, setOpen] = useState(false);
  const [trabajadores, setTrabajadores] = useState([]);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search), 400);
    return () => clearTimeout(t);
  }, [search]);

  const fetchWorkers = useCallback(async (q = '') => {
    setLoading(true);
    try {
      const params = q ? `?search=${encodeURIComponent(q)}` : '';
      const res = await axios.get(`${API}/empresas-mandante2/${empresa.id}/trabajadores${params}`, { headers });
      setTrabajadores(res.data);
    } catch {}
    setLoading(false);
    setLoaded(true);
  }, [empresa.id, token]);

  useEffect(() => {
    if (open && !loaded) fetchWorkers();
  }, [open]);

  useEffect(() => {
    if (open && loaded) fetchWorkers(debouncedSearch);
  }, [debouncedSearch]);

  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden" data-testid={`empresa-card-${empresa.id}`}>
      <button onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 bg-white hover:bg-slate-50 transition-colors text-left">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-[#a05e49]/10 flex items-center justify-center">
            <Building2 className="w-4 h-4 text-[#a05e49]" />
          </div>
          <div>
            <p className="text-sm font-medium text-slate-800">{empresa.razon_social}</p>
            <p className="text-[10px] text-slate-400">RUT: {empresa.rut} | Gerencia: {empresa.gerencia}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs bg-[#a05e49]/10 text-[#a05e49] px-2 py-0.5 rounded-full font-medium">
            {empresa.total_trabajadores} trabajador(es)
          </span>
          {open ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
        </div>
      </button>

      {open && (
        <div className="border-t border-slate-200 p-3 bg-slate-50/50 space-y-3">
          <div className="flex items-center gap-2">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-2 w-3.5 h-3.5 text-slate-400" />
              <input type="text" value={search} onChange={e => setSearch(e.target.value)}
                placeholder="Buscar trabajador por nombre o RUT..."
                className="w-full pl-9 pr-3 py-1.5 border border-slate-200 rounded-lg text-xs bg-white focus:outline-none focus:ring-2 focus:ring-[#a05e49]/20"
                data-testid={`search-empresa-${empresa.id}`} />
            </div>
            <button onClick={() => setShowModal(true)}
              className="flex items-center gap-1 px-3 py-1.5 bg-[#a05e49] text-white text-xs rounded-lg hover:bg-[#8b4f3d] whitespace-nowrap"
              data-testid={`btn-agregar-empresa-${empresa.id}`}>
              <Plus className="w-3.5 h-3.5" /> Agregar
            </button>
          </div>

          <div className="max-h-[300px] overflow-y-auto border border-slate-200 rounded-lg bg-white">
            <table className="w-full" data-testid={`table-empresa-${empresa.id}`}>
              <thead className="sticky top-0 bg-slate-50 z-10">
                <tr className="border-b border-slate-200">
                  <th className="text-left px-3 py-2 text-[10px] font-semibold text-slate-400 uppercase whitespace-nowrap">RUT</th>
                  <th className="text-left px-3 py-2 text-[10px] font-semibold text-slate-400 uppercase">Nombre</th>
                  <th className="text-left px-3 py-2 text-[10px] font-semibold text-slate-400 uppercase">Cargo</th>
                  <th className="text-left px-3 py-2 text-[10px] font-semibold text-slate-400 uppercase">Email</th>
                  <th className="text-left px-3 py-2 text-[10px] font-semibold text-slate-400 uppercase">Telefono</th>
                  <th className="text-center px-3 py-2 text-[10px] font-semibold text-slate-400 uppercase">Estado</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {loading ? (
                  <tr><td colSpan={6} className="px-3 py-6 text-center"><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#a05e49] mx-auto" /></td></tr>
                ) : trabajadores.length === 0 ? (
                  <tr><td colSpan={6} className="px-3 py-6 text-center text-xs text-slate-400">Sin trabajadores registrados</td></tr>
                ) : trabajadores.map(t => (
                  <tr key={t.id} className="hover:bg-slate-50 transition-colors">
                    <td className="px-3 py-1.5 text-[11px] font-mono text-slate-600 whitespace-nowrap">{t.rut}</td>
                    <td className="px-3 py-1.5 text-[11px] text-slate-800 font-medium">{t.nombre}</td>
                    <td className="px-3 py-1.5 text-[11px] text-slate-500">{t.cargo}</td>
                    <td className="px-3 py-1.5 text-[11px] text-slate-500">{t.email}</td>
                    <td className="px-3 py-1.5 text-[11px] text-slate-500">{t.fono || t.movil || ''}</td>
                    <td className="px-3 py-1.5 text-center">
                      <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full ${t.activo ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600'}`}>
                        {t.activo ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-[10px] text-slate-400">{trabajadores.length} trabajador(es)</p>

          {showModal && (
            <ModalAgregarContratista token={token} empresaId={empresa.id} empresaNombre={empresa.razon_social}
              onClose={() => setShowModal(false)} onCreated={() => { fetchWorkers(debouncedSearch); }} />
          )}
        </div>
      )}
    </div>
  );
}

/* ───── Tab Contratistas con paginación ───── */
function PersonasContratistas({ token }) {
  const headers = { Authorization: `Bearer ${token}` };
  const [empresas, setEmpresas] = useState([]);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const PER_PAGE = 8;

  useEffect(() => {
    const t = setTimeout(() => { setDebouncedSearch(search); setPage(1); }, 400);
    return () => clearTimeout(t);
  }, [search]);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const params = debouncedSearch ? `?search=${encodeURIComponent(debouncedSearch)}` : '';
        const res = await axios.get(`${API}/empresas-mandante2${params}`, { headers });
        setEmpresas(res.data);
      } catch {}
      setLoading(false);
    };
    fetch();
  }, [debouncedSearch, token]);

  const totalTrabajadores = empresas.reduce((s, e) => s + e.total_trabajadores, 0);
  const totalPages = Math.ceil(empresas.length / PER_PAGE);
  const paged = empresas.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Buscar empresa contratista..."
            className="w-full pl-10 pr-4 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#a05e49]/20"
            data-testid="search-contratistas" />
        </div>
        <div className="text-xs text-slate-400 whitespace-nowrap">
          {empresas.length} empresa(s) | {totalTrabajadores} trabajador(es)
        </div>
      </div>

      {loading ? (
        <div className="py-12 text-center"><div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#a05e49] mx-auto" /></div>
      ) : empresas.length === 0 ? (
        <div className="py-12 text-center text-sm text-slate-400">No se encontraron empresas contratistas</div>
      ) : (
        <>
          <div className="space-y-2">
            {paged.map(e => <EmpresaCard key={e.id} empresa={e} token={token} />)}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex items-center justify-center gap-2 pt-2" data-testid="pagination-contratistas">
              <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
                className="flex items-center gap-1 px-3 py-1.5 text-xs border border-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-30 disabled:cursor-not-allowed">
                <ChevronLeft className="w-3.5 h-3.5" /> Anterior
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                <button key={p} onClick={() => setPage(p)}
                  className={`w-8 h-8 text-xs rounded-lg transition-colors ${p === page ? 'bg-[#a05e49] text-white' : 'border border-slate-200 hover:bg-slate-50 text-slate-600'}`}>
                  {p}
                </button>
              ))}
              <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
                className="flex items-center gap-1 px-3 py-1.5 text-xs border border-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-30 disabled:cursor-not-allowed">
                Siguiente <ChevronRight className="w-3.5 h-3.5" />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

/* ───── Componente principal ───── */
export default function MantenedorPersonas() {
  const { token } = useAuth();
  const [tab, setTab] = useState('mandante');

  return (
    <div className="max-w-7xl mx-auto space-y-4">
      <div className="flex gap-1 bg-slate-100 p-1 rounded-lg w-fit" data-testid="personas-tabs">
        <button onClick={() => setTab('mandante')}
          className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            tab === 'mandante' ? 'bg-[#1B919B] text-white shadow-sm' : 'text-slate-500 hover:text-slate-700'
          }`} data-testid="tab-mandante">
          <Users className="w-4 h-4" /> Lomas Bayas
        </button>
        <button onClick={() => setTab('contratista')}
          className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            tab === 'contratista' ? 'bg-[#a05e49] text-white shadow-sm' : 'text-slate-500 hover:text-slate-700'
          }`} data-testid="tab-contratista">
          <Building2 className="w-4 h-4" /> Contratistas
        </button>
      </div>

      {tab === 'mandante' && <PersonasMandante token={token} />}
      {tab === 'contratista' && <PersonasContratistas token={token} />}
    </div>
  );
}
